(function () {
  const qs = new URLSearchParams(location.search);
  if (qs.get('open_cart') !== '1') return;

  function tryOpenDrawer() {
    try { document.dispatchEvent(new CustomEvent('theme:cart:open')); } catch (e) {}
    try { window.theme?.cart?.openDrawer?.(); } catch (e) {}

    const selectors = [
      '[aria-controls="CartDrawer"]',
      '#cart-icon-bubble',
      '.header__icon--cart',
      'a[href="/cart"]'
    ];
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) { try { el.click(); return true; } catch (e) {} }
    }
    return false;
  }

  function removeOpenCartParam() {
    try {
      const u = new URL(location.href);
      u.searchParams.delete('open_cart');
      history.replaceState(null, '', u.toString());
    } catch (e) {}
  }

  // Give the theme a moment to mount drawer JS
  setTimeout(function(){
    tryOpenDrawer();
    removeOpenCartParam();
  }, 150);
})();
